const serviceOldActionsPanel = {
  title: 'Ações Abertas de Serviços Anteriores',
  title2: 'AÇÕES ABERTAS E SEM PERGUNTA DE SERVIÇOS ANTERIORES',
  accountable: 'Responsáveis: ',
  deadline: 'Prazo: ',
  serviceDate: 'Data do Serviço: ',
  noAccountable: 'Sem responsável'
};

export default serviceOldActionsPanel;
